<template>
  <section>
    <img
      v-lazy="require('@/assets/sites/' + this.image + '')"
      alt="Image"
      @click="expand ? (expand = false) : (expand = true)"
    />
    <AudioBar v-if="audio && expand" :path="audio" :startTime="0" />
    <p v-if="expand">
      {{ this.text }}
    </p>
  </section>
</template>

<script>
import AudioBar from "@/components/AudioBar.vue";

export default {
  components: {
    AudioBar
  },
  props: {
    image: {
      type: String
    },
    text: {
      type: String
    },
    audio: {
      type: String
    }
  },
  data() {
    return {
      expand: false
    };
  }
};
</script>

<style lang="scss" scoped>
img {
  width: auto;
  height: 30vh;
  object-fit: contain;
}
section {
  background-color: #731233;
  padding: 0.7em;
  margin: 0.3em;
  border-radius: 1em;
}
</style>
